"use client";

import Image from "next/image";
import { useState, useEffect } from "react";

type HeroSliderProps = {
  images: string[];
  fallbackImage: string;
};

export function HeroSlider({ images, fallbackImage }: HeroSliderProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) {
    return (
      <picture>
        <source media="(max-width: 768px)" srcSet="/mujermovil.webp" />
        <Image
          src={fallbackImage}
          alt="Hero fallback"
          width={800}
          height={1000}
          className="h-auto w-full object-cover"
          priority
        />
      </picture>
    );
  }

  return (
    <div className="relative w-full">
      {images.map((img, index) => (
        <div
          key={index}
          className={`flex h-[230px] items-center overflow-hidden transition-opacity duration-1000 lg:h-[420px] ${
            index === currentIndex
              ? "opacity-100"
              : "absolute inset-0 opacity-0"
          }`}
        >
          <Image
            src={img}
            alt={`Slide ${index}`}
            width={800}
            height={1000}
            className="h-auto w-full object-cover"
            priority={index === 0}
          />
        </div>
      ))}
      {images.length > 1 && (
        <div className="absolute right-0 bottom-4 left-0 flex justify-center gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              aria-label={`Go to slide ${index + 1}`}
              className={`h-3 w-3 rounded-full transition-colors ${
                index === currentIndex ? "bg-white" : "bg-white/50"
              }`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
